import { Component, inject, OnInit } from '@angular/core';
import {
  LangChangeEvent,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { CustomTabComponent } from '../../../ui/custom-tab/custom-tab.component';
import { SyncfusionL10nService } from '../../../../shared/utils/syncfusion-l10n.service';
import { LanguageService } from '../../../../core/services/utils/language.service';
import { ButtonComponent } from '../../../ui/button/button.component';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [TranslateModule, CustomTabComponent, ButtonComponent],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.css',
})
export class UserManagementComponent implements OnInit {
  private translate = inject(TranslateService);
  private syncfusionL10n = inject(SyncfusionL10nService);
  private languageService = inject(LanguageService);

  users: any[] = [];
  isRTL = false;
  currentLocale = 'ar';

  translatedHeaders = {
    name: '',
    email: '',
    actions: '',
  };

  userColumns: Array<{
    field: string;
    headerText: string;
    width: number;
    textAlign?: string;
    template?: string;
    freeze?: string;
  }> = [];

  ngOnInit(): void {
    this.currentLocale = this.languageService.getCurrentLang();
    this.isRTL = !this.languageService.isLTR();
    this.loadTranslations();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLocale = event.lang;
      this.isRTL = !this.languageService.isLTR();
      this.loadTranslations();
    });

    // Les comptes vivent dans Keycloak et aucun endpoint ne les expose encore :
    // l'écran reste vide plutôt que d'afficher des utilisateurs inventés.
    // Les vrais comptes se gèrent depuis /admin/professors et /admin/students.
    this.users = [];
  }

  loadTranslations(): void {
    this.translate
      .get(['DATA_TABLE.NAME', 'DATA_TABLE.EMAIL', 'DATA_TABLE.ACTIONS'])
      .subscribe((translations) => {
        this.translatedHeaders = {
          name: translations['DATA_TABLE.NAME'],
          email: translations['DATA_TABLE.EMAIL'],
          actions: translations['DATA_TABLE.ACTIONS'],
        };
        this.buildColumns();
      });
  }

  buildColumns(): void {
    this.userColumns = [
      {
        field: 'name',
        headerText: this.translatedHeaders.name,
        width: 150,
        textAlign: this.isRTL ? 'Right' : 'Left',
      },
      {
        field: 'email',
        headerText: this.translatedHeaders.email,
        width: 150,
        textAlign: this.isRTL ? 'Right' : 'Left',
      },
      {
        field: 'id',
        headerText: '',
        width: 170,
        freeze: 'Right',
        textAlign: 'Center',
        template: 'actionTemplate', // must match ng-template name in grid
      },
    ];
  }

  setGridLanguage(lang: string): void {
    this.currentLocale = lang;
  }

  handleRowClick(user: any): void {
    console.log('Clicked user:', user);
    // Open modal / navigate if needed
  }

  addUser(): void {
    console.log('add user');
  }
  onEditUser(user: any) {
    console.log('Editing user:', user);
  }

  onDeleteUser(user: any) {
    console.log('Deleting user:', user);
  }

  onShowUser(user: any) {
    console.log('Displaying user:', user);
  }
}
